<template>
  <div class="crmeb-layout">
    <aside class="crmeb-sider">
      <PlatformMenu />
    </aside>

    <div class="crmeb-main">
      <header class="crmeb-header">
        <common-home-header/>
      </header>
      <main class="crmeb-content">
        <MultiTabs />
        <div class="crmeb-page">
          <router-view v-slot="{ Component, route }">
            <keep-alive :include="cachedNames">
              <component
                :is="wrapTabComponent(Component, route.name)"
                v-if="Component"
                :key="route.path"
              />
            </keep-alive>
          </router-view>
        </div>
        <footer class="crmeb-footer">
          <PlatformFooter></PlatformFooter>
        </footer>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import PlatformFooter from "@/components/components_platform/PlatformFooter.vue";
import CommonHomeHeader from "@/components/components_business/header/CommonHomeHeader.vue";
import PlatformMenu from "@/components/components_business/menu/PlatformMenu.vue";
import MultiTabs from "@/components/components_business/tabs/MultiTabs.vue";
import { tabsStore } from '@/store/tabs'
import { wrapTabComponent } from '@/utils/tabComponent'

const route = useRoute()
const cachedNames = computed(() => tabsStore.state.cachedNames)

watch(
  () => route.fullPath,
  () => {
    tabsStore.addTab(route)
  },
  { immediate: true }
)
</script>

<style scoped>
.crmeb-layout {
  display: flex;
  min-height: 100vh;
  background: #f0f2f5;
}
.crmeb-sider {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  height: 100vh;
  z-index: 20;
  overflow: visible;
}
.crmeb-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.crmeb-header {
  height: 64px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 10;
}
.crmeb-content {
  margin: 0 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.crmeb-page {
  padding: 16px 0 24px;
  flex: 1;
}
.crmeb-footer {
  padding: 12px 0 20px;
}
</style>
